import { TriangleAlert } from 'lucide-react';
import { useActions, useStrategy } from '@/store/selectors';
import { PopulationMode } from '@/types';
import { Select } from 'calc-controls';
import { populationLabel } from '@/utils/format';

/**
 * Special population selector — collapsible within PatientForm (PSD §8.1.2 / TODO Task 1.23, 3.15).
 * Modes without engine paths are marked disabled "(not yet implemented)" to preserve the
 * information architecture without implying functionality that doesn't exist.
 */
const IMPLEMENTED_MODES: ReadonlySet<PopulationMode> = new Set([
  PopulationMode.Standard,
  PopulationMode.Obesity,
  PopulationMode.Hemodialysis,
]);

export function SpecialPopulationSelector(): JSX.Element {
  const actions = useActions();
  const strategy = useStrategy();
  const standard = strategy.populationMode === PopulationMode.Standard;

  return (
    <section
      className="panel"
      aria-label="Special population selector"
      data-testid="special-population"
    >
      <h2 className="panel-title">Special Population</h2>
      <div data-testid="field-populationMode">
        <Select
          label="Population mode"
          tooltip="Selects a special-population dosing pathway. Non-standard modes require clinical judgment and may block extended-interval dosing."
          options={Object.values(PopulationMode).map((m) => {
            const implemented = IMPLEMENTED_MODES.has(m);
            return {
              value: m,
              label: implemented ? populationLabel(m) : `${populationLabel(m)} (not yet implemented)`,
            };
          })}
          value={strategy.populationMode}
          onChange={(v) => actions.setPopulationMode(v as PopulationMode)}
        />
      </div>
      {!standard && (
        <div className="badge badge-warn">
          <TriangleAlert size={12} strokeWidth={2} aria-hidden="true" />
          Non-standard pathway — use clinical judgment. EI contraindication screening active.
        </div>
      )}
    </section>
  );
}
